import React from "react";

import _ from "lodash";
import cx from "classnames";

import Slider from "src/components/slider";

import styles from "./simulationType.module.scss";
import { useSelector } from "react-redux";
import { CALL_TYPES } from "src/constants/simulation";

interface CreateSimulationDialogProps {
  show: boolean;
  handleClose: () => void;
  // eslint-disable-next-line no-unused-vars
  handleSelect: (id: string) => void;
}

const CreateSimulationDialog: React.FC<CreateSimulationDialogProps> = ({
  show, handleClose, handleSelect
}) => {

  const {creating, type} = useSelector((state: any) => {
    const creating = state.coaching.simulations.creation?.creating;
    const type = state.coaching.simulations.creation?.type;
    return {
      creating,
      type
    }
  });

  return (
    <Slider.Dialog
      show={show}
      width={"380px"}
      className={styles.dialog}
      onClose={() => { }}
    >
      <Slider.Header
        title="select scenario type"
        className={styles.header}
      >
        <button className={styles.closeButton} onClick={handleClose}>
          <i className="paperflite-close" />
        </button>
      </Slider.Header>

      <Slider.Body className={styles.body}>
        {CALL_TYPES.map((option) => (
          <SimulationOption
            key={option.id}
            id={option.id}
            title={option.title}
            description={option.description}
            disabled={creating}
            available={option.enabled}
            creating={type === option.id}
            handleSelect={handleSelect}
          />
        ))}
      </Slider.Body>
    </Slider.Dialog>
  );
};

interface SimulationOptionProps {
  id: string;
  title: string;
  description: string;
  disabled?: boolean;
  creating?: boolean;
  available: boolean;
  // eslint-disable-next-line no-unused-vars
  handleSelect: (id: string) => void;
}

const SimulationOption: React.FC<SimulationOptionProps> = ({
  id,
  title,
  description,
  disabled,
  creating,
  available,
  handleSelect
}) => {

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if(!available) {
      return;
    }

    handleSelect(id);
  };

  return (
    <div className={cx(styles.option, {
      [styles.disabled]: disabled,
      [styles.creating]: creating
    })} onClick={handleClick}>
      <div className={styles.details}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.actions}>
        {available && !creating &&
          <div className={styles.action}>
            <i className="paperflite-right-arrow" />
          </div>
        }
        {available && creating &&
          <div className={styles.action}>
            <div className={styles.loader} />
          </div>
        }

        {!available &&
          <div className={cx(styles.action, styles.comingSoon)}>
            Coming soon
          </div>
        }
      </div>
    </div>
  );
};

export default CreateSimulationDialog;
